import React from 'react';

const SkeletonPulse = ({ className = '' }) => (
  <div className={`animate-pulse bg-white/10 rounded-lg ${className}`} />
);

export const EmailSkeleton = () => (
  <div className="space-y-3">
    {[...Array(6)].map((_, i) => (
      <div key={i} className="glass-card p-4">
        <div className="flex items-start gap-3">
          <SkeletonPulse className="w-10 h-10 rounded-xl flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <SkeletonPulse className="h-3 w-3/4" />
            <SkeletonPulse className="h-4 w-full" />
            <SkeletonPulse className="h-3 w-5/6" />
            <SkeletonPulse className="h-3 w-1/4" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const DashboardSkeleton = () => (
  <div className="space-y-5">
    <div className="glass-card p-6">
      <div className="flex items-center gap-3">
        <SkeletonPulse className="w-10 h-10 rounded-xl" />
        <div className="space-y-2 flex-1">
          <SkeletonPulse className="h-5 w-1/3" />
          <SkeletonPulse className="h-3 w-1/2" />
        </div>
      </div>
    </div>
    <SkeletonPulse className="h-14 w-full rounded-xl" />
    <SkeletonPulse className="h-12 w-full rounded-xl" />
    <div className="grid grid-cols-2 gap-3">
      <SkeletonPulse className="h-28 rounded-2xl" />
      <SkeletonPulse className="h-28 rounded-2xl" />
    </div>
    <SkeletonPulse className="h-32 w-full rounded-2xl" />
  </div>
);

export const AdminSkeleton = () => (
  <div className="space-y-4">
    <div className="flex gap-2">
      {[...Array(4)].map((_, i) => (
        <SkeletonPulse key={i} className="flex-1 h-10 rounded-xl" />
      ))}
    </div>
    <div className="glass-card p-4 space-y-3">
      <SkeletonPulse className="h-4 w-1/3" />
      <div className="grid grid-cols-2 gap-3">
        <SkeletonPulse className="h-24 rounded-xl" />
        <SkeletonPulse className="h-24 rounded-xl" />
      </div>
      <SkeletonPulse className="h-32 rounded-xl" />
    </div>
  </div>
);

export const MappingSkeleton = () => (
  <div className="space-y-3">
    <SkeletonPulse className="h-10 w-full rounded-xl" />
    {[...Array(4)].map((_, i) => (
      <div key={i} className="py-3 flex items-center justify-between">
        <div className="space-y-2 flex-1">
          <SkeletonPulse className="h-4 w-2/3" />
          <SkeletonPulse className="h-3 w-1/3" />
        </div>
        <SkeletonPulse className="w-8 h-8 rounded-lg" />
      </div>
    ))}
  </div>
);

export const SendFileSkeleton = () => (
  <div className="space-y-5">
    <SkeletonPulse className="h-6 w-1/3" />
    <SkeletonPulse className="h-48 w-full rounded-2xl" />
    <SkeletonPulse className="h-10 w-full rounded-xl" />
    <SkeletonPulse className="h-12 w-full rounded-xl" />
  </div>
);

export default SkeletonPulse;
